/* This example requires Tailwind CSS v2.0+ */
import React from "react"
import Image from "../../images/image"
import { Link, navigate } from "gatsby"
import Icon from "../../images/icons/icons"
import useCategoryMetadata from "../categories/staticCategoryData"
import { transformCategory } from "../../utils/transformText"

export default function BlogCardWithImageAndDesc({ post, isContentful }) {
	const categoryData = useCategoryMetadata()

	const goToBlog = (url) => {
		isContentful
			? navigate(url, {
					state: { categorySlug: post.category.slug },
			  })
			: navigate(url, {
					state: { categorySlug: post.frontmatter?.category[0] },
			  })
	}

	return (
		<>
			<div className="flex flex-col rounded-lg shadow-lg overflow-hidden text-left p-6 border relative z-[1]">
				{isContentful ? (
					<div
						className="cursor-pointer"
						onClick={() => goToBlog(`/${post.category.slug}/blog/${post.slug}`)}
						onKeyDown={() => goToBlog(`/${post.category.slug}/blog/${post.slug}`)}
						role="button"
						tabIndex={0}
					>
						{post.featureImage && (
							<div className="flex-shrink-0">
								<Image
									image={post.featureImage}
									className={`h-48 w-full object-cover`}
									imgClassName={`rounded-t-lg`}
									alt={post.featureImage.title}
								/>
							</div>
						)}
						<div className="flex-1 bg-white mt-2 flex flex-col justify-between">
							<div className="flex-1">
								<Link
									to={`/${post.category.slug}/blog/${post.slug}`}
									className="block mt-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500"
								>
									<p className="text-xl font-bold text-gray-900 tracking-tight">{post.title}</p>
								</Link>
								{!post.featureImage && (
									<div className="text-medium text-gray-600 font-normal mb-4">
										{post.shortDescription?.shortDescription}
									</div>
								)}
							</div>
							<div className="pt-2 flex justify-between">
								<div className="flex items-center space-x-1">
									<div className="flow-root">
										<div className="text-sm text-gray-500">
											<Icon
												iconName="Calendar"
												className="mr-1"
											/>
										</div>
									</div>

									<div className="flow-root">
										<div className="text-sm text-gray-500">
											<time dateTime={post.publishedDate}>{post.publishedDate}</time>
										</div>
									</div>
								</div>

								<div className="flex-shrink-0">
									<div className="text-sm font-medium text-primary-700 mb-0 border px-2 py-1 border-primary-700 rounded-3xl">
										{post.category.name}
									</div>
								</div>
							</div>
						</div>
					</div>
				) : (
					<>
						<div
							className="flex-1 bg-white mt-2 flex flex-col justify-between cursor-pointer"
							onClick={() => goToBlog(post.frontmatter.slug)}
							onKeyDown={() => goToBlog(post.frontmatter.slug)}
							role="button"
							tabIndex={0}
						>
							<div className="flex-1">
								<Link
									to={post.frontmatter.slug}
									className="block mt-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500"
								>
									<p className="text-xl font-bold text-gray-900 tracking-tight">
										{post.frontmatter.title}
									</p>
								</Link>

								<div className="text-medium text-gray-600 font-normal mb-4">
									{post.frontmatter.description}
								</div>
							</div>
							<div className="pt-2 flex justify-between">
								<div className="flex items-center space-x-1">
									<div className="flow-root">
										<div className="text-sm text-gray-500">
											<Icon
												iconName="Calendar"
												className="mr-1"
											/>
										</div>
									</div>

									<div className="flow-root">
										<div className="text-sm text-gray-500">
											<time dateTime={post.frontmatter.date}>{post.frontmatter.date}</time>
										</div>
									</div>
								</div>

								<div className="flex-shrink-0">
									{post.frontmatter.category &&
										post.frontmatter.category.map((item, index) => (
											<div
												key={index}
												className="text-sm font-medium text-primary-700 mb-0 border px-2 py-1 border-primary-700 rounded-3xl"
											>
												{transformCategory(item, categoryData.edges)}
											</div>
										))}
								</div>
								{/* <div className="flex-shrink-0">
                  <span className="sr-only">
                    {item.author.firstName} {item.author.lastName}
                  </span>
                  <Image
                    className="h-10 w-10 rounded-full"
                    imgClassName={`rounded-full`}
                    image={item.author.profilePicture}
                    alt={item.author.firstName + " " + item.author.lastName}
                  />
                </div> */}
							</div>
						</div>
					</>
				)}
			</div>
		</>
	)
}
